import { useState, useEffect, useCallback } from 'react';
import * as Sentry from '@sentry/react';
import { supabase } from '@/lib/supabaseClient';
import { toast } from 'sonner';

/**
 * Devuelve los días festivos para una empresa dada.
 */
export function useDiasFestivos(idEmpresa: string) {
  const [diasFestivos, setDiasFestivos] = useState<string[]>([]);

  const fetchDiasFestivos = useCallback(async () => {
    if (!idEmpresa) return;

    const { data, error } = await supabase
      .from('vista_dias_festivos')
      .select('fecha')
      .eq('id_empresa', idEmpresa);

    if (error) {
      Sentry.captureException(error, { extra: { idEmpresa } }); // 👈
      toast.error('Error al cargar días festivos');
    } else {
      setDiasFestivos(data.map((f) => f.fecha));
    }
  }, [idEmpresa]);

  useEffect(() => {
    fetchDiasFestivos();
  }, [fetchDiasFestivos]);

  return diasFestivos;
}
